
import { Component, Vue } from "vue-property-decorator";
import { types } from "@/store";
import offlinelogo from "@/components/svg/cw-mc-icon-color.svg";
import onlinelogo from "@/components/svg/cw-mc-icon-white.svg";
import { IAuthService, ISyncService } from "@/services";
import { inject } from "inversify-props";

@Component({ components: { offlinelogo, onlinelogo } })
export default class MCHeader extends Vue {
  @inject() private authService!: IAuthService;
  @inject() private syncService!: ISyncService;

  get isSyncing() {
    return this.$store.getters[types.state.isSyncing];
  }

  get isOnline() {
    return this.$store.getters[types.state.isOnline];
  }
}
